export default __webpack_public_path__ + "static/media/map-marker.0d67b312.svg";